import { ClickEvent, TableRow } from "@mcleod/components";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutMarketingPlan } from "./autogen/AutogenLayoutMarketingPlan";
import { MarketingPlanDetail } from "./MarketingPlanDetail";

const viewCarrierPlanUrl = "lme/crm/MarketingPlan?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "market_plan",
    screenName: "Marketing Plan",
    navigateToUrl: viewCarrierPlanUrl,
    compositeKeyValues: {
        "type_of": "C"
    }
};

export class MarketingPlan extends AutogenLayoutMarketingPlan {

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    tableMarketPlanDetailOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        tableRow.showEditLayout();
    }

    buttonAddActivityOnClick(event: ClickEvent) {
        MarketingPlanDetail.showAdd({
            onSave: (updatedRow) => {
                updatedRow.set('mark_plan_id', this.activeRow.get('id'));
                this.tableMarketPlanDetail.addRow(updatedRow, null, { display: true, addToData: true });
            }
        });
    }
}